module.exports = __webpack_public_path__ + "img/download_bk.9ad8b048.png";